import $ from "jquery";
import { clickButtonAction, clickButtonUrl, messagePostBot, clickVote } from "#scripts/dialog/dialog_messages.js";
import { restartDialog, deleteDialog, chatFocus, hideChat } from "#scripts/dialog/dialog_general.js";
import { isMobile } from "#scripts/general_functions.js";
import { search } from "#scripts/dialog/dialog_search.js";
import { getAimData } from "#scripts/dialog/dialog_aim.js";

export const dialogEvents = () => {
	$("body").on("keyup", "#tilbakemelding", function (event) {
		const counter = document.getElementById("chatinput__char-counter");
		const chatInput = document.getElementById("tilbakemelding");
		counter.innerText = `${chatInput.value.length}/${chatInput.maxLength}`;
		const key = event.keyCode || event.which;

		if (key === 13 && $(this).val().length > 0) {
			counter.innerText = "";
			messagePostBot($(this).val());
			expandDialog();
			$(this).val("");
		}
	});

	window.visualViewport.addEventListener("scroll", (e) => {
		if (isMobile()) {
			const chatContainer = $(".chatbot__container");
			if (chatContainer.hasClass("chatbot__mobile-show")) {
				chatContainer.height = window.innerHeight;
			}
		}
	});

	$("body").on("click", "#chatbot__modal__close", () => {
		hideChat(true);
		$(".chatbot__mobile-show").removeClass("chatbot__mobile-show");
		$("main").show();
		$("footer").show();
		$(".navbar").show();
		$(".warnings").show();
		$("body").removeClass("overflow-hidden");
	});

	$("body").on("click", "#chatbot__modal__option, #chatbot__infopage__close, .dialog__infopage__container .dialog__actions__ddlink", () => {
		// hideChat(true)
		//   $(".chatbot__mobile-show").removeClass("chatbot__mobile-show");
		//   $("body").removeClass("overflow-hidden");

		$(".chatbot__modal__option").toggleClass("chatbot__modal__option-active");
		$(".chatbot__infopage").toggle();
	});

	$("body").on("click", "button.dialog__fromkari__link", function () {
		if (!isMobile()) {
			//mobile uses touchstart instead
			clickButtonAction($(this).data("id"));
		}
	});

	$("body").on("touchstart", "button.dialog__fromkari__link", function () {
		clickButtonAction($(this).data("id"));
	});

	$("body").on("click", "a.dialog__fromkari__link", function (e) {
		if (!isMobile()) {
			//mobile uses touchstart instead
			clickButtonUrl($(this).data("id"));
			window.location.assign(`${this.href}`);
		}
	});

	$("body").on("touchstart", "a.dialog__fromkari__link", function (e) {
		clickButtonUrl($(this).data("id"));
		window.location.assign(`${this.href}`);
	});

	$("body").on("click", "button.dialog__feedback__button", function () {
		const val = $(this).data("value");
		let remove = "";

		if ($(this).hasClass("active")) {
			remove = "remove-";
		}

		$(this).siblings('.btn').removeClass('active');
		$(this).addClass('active');
		// $(this).toggleClass("active");

		clickVote($(this).data("id"), remove + val);
	});

	$("body").on("click", ".deletedialog", () => {
		deleteDialog();
	});

	$("body").on("click", ".restart-chat", () => {
		restartDialog();
	});

	$("body").on("click", ".hidechat", () => {
		chatFocus(true, false);
		hideChat(true);
	});

	$("body").on("focus", "#tilbakemelding", (e) => {
		// if (isMobile()) {
		// 	$(".chatbot__container").addClass("chatbot__mobile-show");
		// 	const chatContainer = document.getElementById("chatbot__container");
		// 	const chatMessagearea = document.getElementById("chatbot__messagearea");
		// 	hideChat(false);
		// 	if (chatContainer.classList.contains("chatbot__mobile-show")) {
		// 		chatMessagearea.scrollTo(0, chatMessagearea.scrollHeight);
		// 		chatContainer.height = window.visualViewport.height;
		// 	}
		// } else {
		// 	if ($(".dialog__fromuser").length < 1) {
		// 		$(".chatbot-search--container").addClass("transform-bg");
		// 	}
		// 	hideChat(false);
		// }
	});

	$("body").on("click", ".dialog__askbutton", () => {
		$(".chatbot__container").addClass("chatbot__mobile-show");
		const chatContainer = document.getElementById("chatbot__container");
		const chatMessagearea = document.getElementById("chatbot__messagearea");

		hideChat(false);
		if (chatContainer.classList.contains("chatbot__mobile-show")) {
			chatMessagearea.scrollTo(0, chatMessagearea.scrollHeight);
			chatContainer.height = window.visualViewport.height;
		}
	});

	$("body").on("click", "a.dialog__fromkari__mal_blokk", function (e) {
		e.preventDefault();
		e.stopPropagation();
		const id = $(this).data("id");

		if ($(this).data("search")) {
			search($(this).data("search"));

			return;
		}
		getAimData(id); // HER ER FAIL
	});

	$("body").on("click", ".dialog__sendbutton", () => {
		expandDialog();
		const inputfield = $("#tilbakemelding");
		if (inputfield.val() !== "") {
			messagePostBot(inputfield.val());
			inputfield.val("");
		}
		if (!isMobile()) {
			inputfield.focus();
		}
	});

	$("body").on("click", ".dialog__actions__toggle", function (e) {
		e.preventDefault();

		$(this).toggleClass("dialog__actions__link-active");
		$(".dialog__chevron__toggle").toggleClass("material-chevron-bottom material-chevron-top");
		$(".dialog__actions").toggleClass("dialog__actions__show");
	});

	$("body").on("click", ".dialog__actions__ddlink", () => {
		$(".dialog__chevron__toggle").toggleClass("material-chevron-bottom material-chevron-top");
		$(".dialog__actions").toggleClass("dialog__actions__show");
		$(".dialog__actions__toggle").toggleClass("dialog__actions__link-active");
	});

	window.onresize = () => {
		if (isMobile()) {
			$(".chatbot__container").addClass("chatbot__mobile");
		} else {
			$(".chatbot__container").removeClass("chatbot__mobile");
		}
	};
};

const expandDialog = () => {
	if (isMobile()) {
		$(".chatbot__container").addClass("chatbot__mobile-show");
		const chatContainer = document.getElementById("chatbot__container");
		const chatMessagearea = document.getElementById("chatbot__messagearea");
		hideChat(false);
		if (chatContainer.classList.contains("chatbot__mobile-show")) {
			chatMessagearea.scrollTo(0, chatMessagearea.scrollHeight);
			chatContainer.height = window.visualViewport.height;
		}
	} else {
		if ($(".dialog__fromuser").length < 1) {
			$(".chatbot-search--container").addClass("transform-bg");
		}
		hideChat(false);
	}
};
